<div class="split left">
  <header>
    <div class="main-header d-flex justify-content-between align-items-center">
      <div class="logo default-pointer" (click)="navigate()">
        <img src="../../assets/automapai-logo.png" class="header-termhub-logo" alt="AutomapAI" />
      </div>
    </div>
  </header>

  <div class="signup-body">
    <div>
      <span class="header-text forgot-header-text green-title"
        ><img src="../../assets/check-circle.png" class="body-circled-check" alt="Check" /> Email Sent</span
      >

      <div>
        <div class="form-section">
          <span class="default-font">An email has been sent. If an account exists, you will receive further instructions. </span>
        </div>
        <div class="form-section">
          Didn't receive an email? <a class="form-link" href (click)="resendPasswordResetEmail()">Resend reset instructions</a>
          or
          <a class="form-link" [routerLink]="'/password-reset'">re-enter your email address.</a>
        </div>
      </div>
    </div>
  </div>
  <div class="split right tinted-image"></div>
</div>
